import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t, useLocale } from '@mcex/locale';
import { PageEnum } from '/@/enums/pageEnum';
import { RoleEnum } from '/@/enums/roleEnum';
import { useUserStore } from '/@/store/modules/user';
import { useRegisterFormStore } from '/@/store/modules/registerForm';
import { StatusTypeEnum } from '/@/enums/accountEnum';
import { MEMBER_DOMAIN_MAP } from '/@/api/const';
import { unref } from 'vue';

const { getLocale } = useLocale();
const IFrame = () => import('/@/views/sys/iframe/index.vue');

export const AccountRoute: AppRouteModule = {
  path: '/account',
  name: 'AccountManagement',
  component: LAYOUT,
  redirect: PageEnum.ACCOUNT_AGREEMENT,
  meta: {
    hideMenu: true,
    orderNo: 11,
    icon: 'streamline:money-cash-dollar-coin-accounting-billing-payment-cash-coin-currency-money-finance',
    title: t('routes.account.manage'),
  },
  children: [
    {
      path: 'agreement',
      name: 'Agreement',
      component: IFrame,
      meta: {
        // affix: true,
        title: t('routes.account.agreement'),
        frameSrc: () => {
          const userStore = useUserStore();
          const token = userStore.getToken;
          const refreshToken = userStore.getRefreshToken;
          const { host, protocol, pathname } = window.location;
          const memberUrl = `${protocol}//${
            MEMBER_DOMAIN_MAP[host].homeDigit
          }${pathname}?frame=true&token=${encodeURIComponent(token)}&rt=${encodeURIComponent(
            refreshToken,
          )}&lang=${unref(getLocale)}&redirect=${PageEnum.ACCOUNT_AGREEMENT}`;
          return memberUrl;
        },
      },
      beforeEnter: () => {
        const registerFormStore = useRegisterFormStore();
        const status = registerFormStore.getStatus;
        if (status === StatusTypeEnum.APPLICATION_REVIEWING) {
          return { path: PageEnum.ACCOUNT_REGISTER };
        }
        const userStore = useUserStore();
        if (userStore.getRoleList.includes(RoleEnum.ORDINARY)) {
          return true;
        }
        return { path: PageEnum.BASE_HOME };
      },
    },
    {
      path: 'register',
      name: 'AccountManagementPage',
      component: IFrame,
      meta: {
        dynamic: true,
        // affix: true,
        title: '',
        frameSrc: () => {
          // TODO 重定向到会员页
          const userStore = useUserStore();
          const token = userStore.getToken;
          const refreshToken = userStore.getRefreshToken;
          const { host, protocol, pathname } = window.location;
          const memberUrl = `${protocol}//${
            MEMBER_DOMAIN_MAP[host].homeDigit
          }${pathname}?frame=true&token=${encodeURIComponent(token)}&rt=${encodeURIComponent(
            refreshToken,
          )}&lang=${unref(getLocale)}&redirect=${PageEnum.ACCOUNT_REGISTER}`;
          return memberUrl;
        },
      },
      beforeEnter: (to) => {
        const registerFormStore = useRegisterFormStore();
        const mType = registerFormStore.memberCategory;
        to.meta.title = t(`account.document.memberCategory${mType}`);

        const userStore = useUserStore();

        // 普通会员
        if (userStore.getRoleList.includes(RoleEnum.ORDINARY)) {
          return true;
        }

        // 正式会员
        return { path: PageEnum.BASE_HOME };
      },
    },
  ],
};

export default AccountRoute;
